/**
 * This function first checks to see if there is an existing link to the stylesheet you want and if there isn't,
 * then the link will be added.
 * @param url The url of the stylesheet to import
 */
export function loadStylesheet(url) {
    const existingStyleSheet = document.querySelector(`link[href="${url}"]`);
    if (existingStyleSheet == null) {
        const newLink = document.createElement('link');
        newLink.setAttribute('rel', 'stylesheet');
        newLink.setAttribute('href', url);
        document.head.appendChild(newLink);
    }
}
